import { useEffect, useRef, useState } from 'react';

export const useTransientState = (duration: number) => {
  const [isActive, setIsActive] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const trigger = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setIsActive(true);
    timerRef.current = setTimeout(() => setIsActive(false), duration);
  };

  useEffect(
    () => () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    },
    [],
  );

  return { isActive, trigger };
};
